var itemsRunOnce = 0;
class cAdminDocuments {
    constructor() {
        var self = this;
        // Only run on /items/ pages.
        if (window.location.href.indexOf('/items/') > -1) {
            if (!itemsRunOnce) {
                this.onload();
                itemsRunOnce = 1;
            }
        }
    }
    onload() {
        var self = this;
        var elBtnAddDocument = $('#add-document-btn');
        var elBtnEditDocument = $('.edit-document-btn');
        var elBtnDeleteDocument = $('#delete-document-btn');
        var elDocumentTable = $('#book-table');
        var elBtnBulkUpload = $('#bulk-import-btn');
        var elBtnPdfUpload = $('#bulk-pdf-import-btn');
        this.elDocumentAddForm = $('#book-add-form');
        this.elDocumentEditForm = $('#book-edit-form');
        this.elDocumentBulkUploadForm = $('#bulk-upload-form');
        this.elDocuments = $('#new-books');
        this.elsDocumentsFields = $('#edit-booksfields input');
        this.elSelectItemtType = $('#book-add-form #documenttype');
        this.elInputTreatAsSingleItem = $('#treat-as-single-item');
        elDocumentTable.click(function (e) {
            self.bookTableClickHandler(e);
        });
        $('.new-book-file-input').first().on("change", function () {
            self.insertDocumentAddInput($(this));
        });
        // $(this.elDocumentAddForm).submit(function(e) {
        //     return self.submitAddDocument(this, $('#add-document-btn'), e);
        // });
        $(elBtnEditDocument).click(function (e) {
            return self.submitEditDocument(this, e);
        });
        $(elBtnDeleteDocument).click(function (e) {
            return self.onDocumentDelClick($(this).data('id'));
        });
        $(this.elSelectItemtType).change(function (e) {
            return self.onAddItemTypeChange($(this).val());
        });
        $(elBtnBulkUpload).on('click submit', function (e) {
            return self.submitBulkUpload(this, $('#bulk-import-btn'), e);
        });
        $(elBtnPdfUpload).on('click submit', function (e) {
            return self.submitPdfUpload(this, $('#bulk-pdf-import-btn'), e);
        });

        $("#limit").on('change', function (e) {
            var limit = $(this).val();
            var offset = $(this).data('offset');
            var s = $(this).data('s');
            var path = $(this).data('path') ? $(this).data('path') : '/items/listitems/';
            if (s) {
                window.location = path + '?s=' + s + '&offset=' + offset + '&limit=' + limit;
            } else {
                window.location = path + '?offset=' + offset + '&limit=' + limit;
            }
        });

        $(elDocumentTable).dataTable({
            'dom': '<"row"<"col-sm-12" p>><"row"<"col-sm-6" l><"col-sm-6" f>><t><"row" <"col-sm-6" p>>',
            'paging': false,
            'ordering': true,
            'info': true,
            'pageLength': 500,
            'lengthMenu': -1,
            'lengthChange': false,
            'order': [[1, 'asc']],
            'columnDefs': [
                { "orderable": false, "targets": 0 }
            ],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Items per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });
    }
    onAddItemTypeChange(idSelected) {
        if (idSelected == 6 || idSelected == 7) {
            $("#book-add-form #format-form-group").hide();
            $("#book-add-form #definition-form-group").hide();
            $("#book-add-form #pdf-password-form-group").hide();
            $("#book-add-form #pdf-password-form-group").val('');
        }
        else {
            $("#book-add-form #format-form-group").show();
            $("#book-add-form #definition-form-group").show();
            $("#book-add-form #pdf-password-form-group").show();
        }
    }
    getDocumentsFieldsValue(bookId, fieldId) {
        for (var i in g_books_booksFieldsValues) {
            if (g_books_booksFieldsValues[i]['books_id'] == bookId && g_books_booksFieldsValues[i]['books_fields_id'] == fieldId) {
                return g_books_booksFieldsValues[i];
            }
        }
        return false;
    }

    /*Method too fragile and jquery library not showing errors. Deprecated.*/
    submitAddDocument(form, btn, e) {
        var notify_upload_complete = false;
        if (!$('.new-book-file-input')[0].files.length) {
            notify.error("No documents set for upload.");
        }
        else if (!$('#new-title-1').val()) {
            notify.error("Title not specified for the first document");
        }
        else if ($('.new-book-file-input')[1] && $('.new-book-file-input')[1].files.length && !$('#new-title-2').val() && !$('#treat-as-single-item').is(":checked")) {
            notify.error("Title not specified for the second document");
        }
        else if ($('.new-book-file-input')[2] && $('.new-book-file-input')[2].files.length && !$('#new-title-3').val() && !$('#treat-as-single-item').is(":checked")) {
            notify.error("Title not specified for the third document");
        }
        else {
            $(btn).button('loading');
            $(form).ajaxSubmit({
                dataType: 'json',
                uploadProgress: function (event, position, total, percentComplete) {
                    $("#add-edit-document-progress-bar .progress-bar").width(percentComplete + '%');
                    $("#add-edit-document-progress-bar .progress-bar").html(percentComplete + '% Uploaded');
                    if (percentComplete == 100 && !notify_upload_complete) {
                        notify.success("Upload has been completed. Please wait for further intermediary processing to complete ...");
                        notify_upload_complete = true;
                    }
                },
                beforeSend: function (jqXHR) {
                    $("#add-edit-document-progress-bar .progress-bar").width('0%').html('0% Uploaded');
                },
                success: function (response, statusText, xhr, el) {
                    if (response.success) {
                        notify.success(response.message);
                        setTimeout(function () {
                            window.location = URL_ADMIN + '/items/listitems/';
                        }, 2000);
                    }
                    else {
                        notify.error(response.errors[0]);
                    }
                    $(btn).button('reset');
                },
                error: function (jqXHR) {
                    return ajaxErrorCallback(jqXHR, btn);
                },
                complete: function () {
                }
            });
        }
        return false;
    }
    submitEditDocument(btn, e) {
        $(btn).button('loading');
        $('#book-edit-form').ajaxSubmit({
            url: URL_ADMIN + '/items/updateitem/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }

    submitBulkUpload(form, btn, e) {

        if (!this.validateFileLimits('opfxml-files')) {
            return false;
        }

        $(btn).button('loading');
        $('#bulk-upload-form').ajaxSubmit({
            url: URL_ADMIN + '/items/savebulkimport/',
            type: 'post',
            dataType: 'json',
            uploadProgress: function (event, position, total, percentComplete) {
                $("#bulk-upload-progress-bar .progress-bar").width(percentComplete + '%');
                $("#bulk-upload-progress-bar .progress-bar").html(percentComplete + '% Uploaded');
                if (percentComplete == 100 && !notify_upload_complete) {
                    notify.warn("Upload complete. Metadata is now being processed ...", { timeout: 7000 });
                    notify_upload_complete = true;
                }
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message, { timeout: 7000 });
                }
                else {
                    for (var i = 0; i < response.errors.length; i++) {
                        notify.error(response.errors[i]);
                    }
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }

    submitPdfUpload(form, btn, e) {

        if (!this.validateFileLimits('pdf-files')) {
            return false;
        }

        var notify_upload_complete = false;
        $(btn).button('loading');
        $('#bulk-files-form').ajaxSubmit({
            url: URL_ADMIN + '/items/savebulkimportpdfs/',
            type: 'post',
            dataType: 'json',
            uploadProgress: function (event, position, total, percentComplete) {
                $("#upload-document-progress-bar .progress-bar").width(percentComplete + '%');
                $("#upload-document-progress-bar .progress-bar").html(percentComplete + '% Uploaded');
                if (percentComplete == 100 && !notify_upload_complete) {
                    notify.warn("Uploading complete. Please wait while the files are being processed ...", { timeout: 7000 });
                    notify_upload_complete = true;
                }
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    for (var i = 0; i < response.errors.length; i++) {
                        notify.error(response.errors[i]);
                    }
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }

    validateFileLimits(elId) {
        console.log(elId);
        let filesInput = document.getElementById(elId);
        let numFiles = filesInput.files.length;
        let maxFiles = filesInput.getAttribute('data-max-files');
        let maxSize = filesInput.getAttribute('data-max-size-bytes');

        if (numFiles > maxFiles) {
            alert("You are trying to upload more than the maximum allowed " + maxFiles + " files. Please reduce the number of files and try again.");
            return false;
        }

        let totalbytes = 0;
        for (let i = 0; i < filesInput.files.length; i++) {
            totalbytes += filesInput.files[i].size;
        }
        console.log(totalbytes, maxSize);
        if (totalbytes && totalbytes > maxSize) {
            alert("Your upload exceeds the maximum file upload limit. Please reduce the total size of the upload and try again.");
            return false;
        }
        return true;
    }


    bookTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);
        if ($(target).hasClass('edit')) {
            this.onDocumentEditClick(row);
        } else if ($(target).hasClass('trash')) {
            this.onDocumentDelClick(row.getAttribute('rel'), 'trash');
        } else if ($(target).hasClass('del-permanent')) {
            this.onDocumentDelClick(row.getAttribute('rel'), 'permanent');
        } else if ($(target).hasClass('undelete-btn')) {
            this.onDocumentUndeleteClick(row.getAttribute('rel'), 'undelete');
        }
    }
    onDocumentEditClick(row) {
        window.location = '/items/edititem/' + $(row).data('document-id');
    }
    getDocumentById(bookId) {
        for (var i in g_books_books) {
            if (g_books_books[i].id == bookId) {
                return g_books_books[i];
            }
        }
        return null;
    }

    onDocumentUndeleteClick(item_id, type) {
        if (type === 'undelete' && confirm('Are you sure you want to restore this item from the recycle bin?')) {
            return this.deleteDocument(item_id, 'undelete');
        }
    }

    onDocumentDelClick(item_id, type) {
        if (type === 'trash' && confirm('Are you sure you want to send this item to the recycle bin?')) {
            return this.deleteDocument(item_id, 'trash');
        } else if (type === 'permanent' && confirm('Are you sure you want to permanently delete this item? This action cannot be undone.')) {
            return this.deleteDocument(item_id, 'destroy');
        }
        return false;
    }

    deleteDocument(item_id, type) {
        $.ajax({
            url: URL_ADMIN + '/items/' + type + '/',
            type: 'post',
            dataType: 'json',
            data: {
                'item_id': item_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR);
            },
        });
        return false;
    }
}
